angular.module('rjmNg.services').factory 'dimensionService', [
  "$rootScope"
  "rjqlStringConstants"
  "utils"
  ($rootScope, rjqlStringConstants, utils) ->

    dimensionService = {}

    # Returns whether a metric is independent based on whether it contains a
    # metric with the sid ':unbound'
    _metricIsIndependent = (metric) ->
      for dimension in metric.dimensions
        if dimension and dimension.column_id is rjqlStringConstants.RJQL_UNBOUND
          return true

      return false

    # Given an array, returns an array of unbound dimensions with the same
    # length
    dimensionService.getUnboundDimensionList = (dimensions) ->
      return dimensions.map ->
        name: rjqlStringConstants.RJQL_UNBOUND_NAME
        column_id: rjqlStringConstants.RJQL_UNBOUND

    # Returns a list of dimensions in which each element is equal to that in
    # `existingDimensions` if that dimension is available in `newDimensionList`
    # or `null` otherwise.
    dimensionService.getDimensionMap = (existingDimensions, newDimensionList) ->
      existingDimensions.map (dim) ->
        sids = newDimensionList.map (dim) -> return dim.column_id
        if dim? and sids.indexOf(dim.column_id) isnt -1
          return dim
        else
          return null

    # Returns an array of metrics formatted for the dimension grid.
    dimensionService.getDimensionGridMetrics = (metrics) ->
      dimensionGridMetrics = []

      for metric in metrics when metric.type is 'metric'
        dimensionGridMetric =
          name: metric.name
          alias: metric.alias
          dimensionList: metric.dimensionList
          tableName: metric.tableName
          originalMetric: metric
          independent: _metricIsIndependent(metric)

        if dimensionGridMetric.independent
          # Use an array of nulls in case the metric is set to not independent.
          dimensionGridMetric.dimensions = metric.dimensions.map -> null
        else
          dimensionGridMetric.dimensions = utils.copy(metric.dimensions)

        dimensionGridMetrics.push(dimensionGridMetric)

      return dimensionGridMetrics

    _metricResolverSubmit = (scope) ->
      lastMetric = scope.metrics[scope.metrics.length - 1]

      scope.resolvedDimensionsPromise.resolve switch
        when not lastMetric.independent then lastMetric.dimensions
        else dimensionService.getUnboundDimensionList(lastMetric.dimensions)

    dimensionService.getMetricResolverScope = (metrics, newMetric, resolvedDimensionsPromise) ->
      dimensionGridMetrics = dimensionService.getDimensionGridMetrics(metrics)

      # Add the new metric to the list
      dimensionGridMetrics.push
        name: newMetric.name
        alias: newMetric.alias
        independent: false
        dimensionList: newMetric.dimensionList
        tableName: newMetric.tableName
        dimensions: dimensionService.getDimensionMap(dimensionGridMetrics[0].dimensions, newMetric.dimensionList)

      modalScope = $rootScope.$new()
      modalScope.metrics = dimensionGridMetrics
      modalScope.message = 'To add this metric, please specify how it should be grouped.'
      modalScope.resolvedDimensionsPromise = resolvedDimensionsPromise
      modalScope.submitCallback = _metricResolverSubmit
      modalScope.editableMetricIndices = {}
      modalScope.editableMetricIndices[dimensionGridMetrics.length - 1] = true
      modalScope.forceEnableSubmit = true

      return modalScope

    _dimensionEditorAndResolverSubmit = (scope) ->
      # scope = childScope.$parent

      # Update the metrics with changes from the editor.
      for dimensionGridMetric in scope.metrics
        dimensionGridMetric.originalMetric.dimensions = switch
          when not dimensionGridMetric.independent then dimensionGridMetric.dimensions
          else dimensionService.getUnboundDimensionList(dimensionGridMetric.dimensions)

      if scope.callback?
        scope.callback()

    dimensionService.getDimensionEditorScope = (metrics, callback) ->
      dimensionGridMetrics = dimensionService.getDimensionGridMetrics(metrics)

      modalScope = $rootScope.$new()
      dimensionGridMetrics[0].canSetIndependent = false
      modalScope.metrics = dimensionGridMetrics
      modalScope.submitCallback = _dimensionEditorAndResolverSubmit
      modalScope.callback = callback

      return modalScope

    dimensionService.getDimensionResolverScope = (metrics, dimension, callback) ->
      dimensionGridMetrics = dimensionService.getDimensionGridMetrics(metrics)
      # For each metric, append the selected `dimension`, if available, or null.
      for metric in dimensionGridMetrics
        sids = metric.dimensionList.map (dim) -> return dim.column_id
        if metric.independent or sids.indexOf(dimension.column_id) is -1
          metric.dimensions.push(null)
        else
          metric.dimensions.push(dimension)

      modalScope = $rootScope.$new()
      modalScope.metrics = dimensionGridMetrics
      modalScope.message = 'To add this dimension, please specify the corresponding dimension for the rest of your metrics.'
      modalScope.submitCallback = _dimensionEditorAndResolverSubmit
      modalScope.callback = callback
      modalScope.forceEnableSubmit = true

      return modalScope

    # Update a metric's dimensions when it looses or gains its independence;
    # either set all the dimensions to null, or attempt to match them to
    # dimensions from the first metric.
    dimensionService.updateGridMetricDimensions = (firstMetric, metric) ->
      if metric.independent or firstMetric.independent
        # Set the dimensions to null so if it's switched back to non-independent the previous selections aren't retained.
        metric.dimensions = firstMetric.dimensions.map () -> null
      else
        # Attempt to match the sids to the first metric's sids
        # Neither this metric nor the first metric are independent
        metric.dimensions = dimensionService.getDimensionMap(firstMetric.dimensions, metric.dimensionList)

    dimensionService.getCohortTimeStampDimensions = (dimensionList, timestampColumnId, columns) ->
      return _.filter(dimensionList, (dimension) ->
        dimension.datatype is "DATETIME" and
        dimension.column_id isnt timestampColumnId and
        columns[dimension.column_id]?.properties.derivative_type in ["relocated_field", "aggregate"]
      )

    dimensionService.getAllCohortDimensions = (dimensionList, timestampColumnId, columns) ->
      return _.filter(dimensionList, (dimension) ->
        (dimension.datatype is "DATETIME" and
         dimension.column_id isnt timestampColumnId and
         columns[dimension.column_id]?.properties.derivative_type in ["relocated_field", "aggregate"]) or
        (dimension.datatype isnt "DATETIME" and
         dimension.is_groupable))

    dimensionService

]
